import { jsxs as $, jsx as a } from "react/jsx-runtime";
import k, { useState as y, useEffect as g, useCallback as b } from "react";
import { u as d } from "./index-6a632112.mjs";
import { createPortal as I } from "react-dom";
import { s as e, r as S, c as n, Q as w, p as T, a as z, e as C, l as W, b as E } from "./themes-5f0b3c3d.mjs";
import { z as D } from "./zIndices-d07533f3.mjs";
import { CloseButton as U } from "./closeButton.js";
import { l as _ } from "./lineHeights-72d3110c.mjs";
const A = 3e3, P = () => ` 
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`, F = d.div`
  ${({ $fadeOut: t }) => t ? `
    animation: closeSnackbar 0.3s forwards;
    animation-delay: 0s;

    @keyframes closeSnackbar {
      from {
        opacity: 1;
      }
      to {
        opacity: 0;
        -webkit-transform: translateY(100%);
      }
    }

    ` : `
    animation: openSnackbar 0.3s ease-in-out;
    animation-delay: 0s;
    @keyframes openSnackbar {
      from {
        opacity: 0;
        -webkit-transform: translateY(100%);
      }
      to {
        opacity: 1;
      }
    }
`}
  margin-bottom: ${e["4x"]};
  gap: ${e["2x"]};
  display: flex;
  width: fit-content;
  position: relative;
  padding: ${e["2x"]} ${e["2x"]} ${e["2x"]} ${e["4x"]};
  box-sizing: border-box;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  min-height: ${e["12x"]};
  border-radius: ${S["2x"]};
  background-color: ${({ $type: t }) => t === "error" ? n.utilityDanger[1e3] : n.brandTwilight[900]};
`, L = d.div`
  padding: ${e["1x"]} ${e["3x"]} ${e["1x"]} ${e["1x"]};
`, M = d.p`
  ${P()}
  min-height: ${e["6x"]};
  @media ${w.laptopAndUp} {
    max-width: 240px;
  }
  color: ${n.brandTwilight[0]};
  font-family: ${T};
  font-size: ${z.small};
  font-weight: ${C.medium.M.fontWeight};
  letter-spacing: ${W[0]};
  line-height: ${_.medium};
`, Q = d.button`
  height: ${e["8x"]};
  padding: 2px ${e["4x"]};
  width: auto;
  font-family: ${T};
  color: ${n.brandTwilight[0]};
  border-radius: ${S["2x"]};
  font-weight: ${C.medium.S.fontWeight};
  background-color: ${({ $snackbarType: t }) => t === "error" ? n.utilityDanger[1e3] : n.accentBlue[1e3]};
  cursor: pointer;
  ${(t) => t.$snackbarType === "error" ? `
      border-width : ${E["2x"]};
      border-style : solid;
      border-color : ${n.brandTwilight[0]};
      ` : "border-width : inherit;"}
  &:hover {
    background-color: ${({ $snackbarType: t }) => t === "error" ? n.utilityDanger[1200] : n.accentBlue[1200]};
  }
  &:focus-visible {
    ${(t) => t.$snackbarType !== "error" ? `
     outline: 2px solid ${n.accentBlue[1e3]};
    outline-offset: 2px;` : `
    border: 2px solid white; 
    outline: none !important;`}
  }
`, R = d.div`
  padding: 6px 0px;
  width: auto;
  height: 100%;
  display: flex;
  flex-shrink: 0;
  color: ${n.brandTwilight[0]};
  & > svg {
    width: ${e["5x"]};
    height: ${e["5x"]};
  }
`, Y = ({
  message: t,
  buttonText: s,
  showCloseIcon: o = !1,
  type: i,
  id: u,
  logo: m,
  onButtonClick: r,
  autoCloseTime: l
}) => {
  const c = l || A, { removeSnackBar: h } = G(), [f, x] = y(!1);
  g(() => {
    const p = setTimeout(() => {
      x(!0);
    }, c);
    return () => {
      clearTimeout(p);
    };
  }, [c]), g(() => {
    const p = setTimeout(() => {
      f && h(Number(u));
    }, c);
    return () => {
      clearTimeout(p);
    };
  }, [f, u, h, c]);
  const B = (p) => {
    x(!0);
  };
  return /* @__PURE__ */ $(F, { $fadeOut: f, $type: i, role: "alert", children: [
    m && /* @__PURE__ */ a(R, { children: m }),
    /* @__PURE__ */ a(L, { children: /* @__PURE__ */ a(M, { children: t }) }),
    s && /* @__PURE__ */ a(Q, { $snackbarType: i, onClick: r, children: s }),
    o && /* @__PURE__ */ a(
      U,
      {
        surface: "dark",
        size: "small",
        onClick: () => B()
      }
    )
  ] });
}, H = d.div`
  display: flex;
  flex-direction: column;
  justify-contnet: space-around;
  align-items: center;
  max-width: 90%;
  overflow: hidden;
  @media ${w.laptopAndUp} {
    width: unset;
  }
  width: max-content;
  position: fixed;
  left: 50%;
  transform: translate(-50%, -0%);
  bottom: 0;
  margin-bottom: 80px;
`, N = ({
  snackbars: t,
  style: s
}) => I(
  /* @__PURE__ */ a(H, { style: s, children: t.map((o) => /* @__PURE__ */ a(
    Y,
    {
      id: o.id.toString(),
      message: o.message,
      buttonText: o.buttonText,
      logo: o.logo,
      showCloseIcon: o.showCloseIcon,
      onButtonClick: o.onButtonClick,
      type: o.type,
      autoCloseTime: o.autoCloseTime
    },
    o.id
  )) }),
  document.body
), v = k.createContext(void 0);
let q = 0;
const et = ({
  children: t,
  zIndex: s = D.toast
}) => {
  const [o, i] = y([]), u = b(
    (r) => {
      i((l) => [
        ...l,
        {
          id: q++,
          message: r.message,
          buttonText: r.buttonText,
          logo: r.logo,
          type: r.type,
          showCloseIcon: r.showCloseIcon,
          onButtonClick: r.onButtonClick,
          autoCloseTime: r.autoCloseTime
        }
      ]);
    },
    [i]
  ), m = b(
    (r) => {
      i(
        (l) => l.filter((c) => c.id !== r)
      );
    },
    [i]
  );
  return /* @__PURE__ */ $(
    v.Provider,
    {
      value: { addSnackBar: u, removeSnackBar: m },
      children: [
        /* @__PURE__ */ a(N, { snackbars: o, style: { zIndex: s } }),
        t
      ]
    }
  );
}, G = () => k.useContext(v);
export {
  et as S,
  G as u
};
